import api from '_Utils/Api';

export const postcontactService = (req) =>
    api
        .post('/contact/addContact', req.data)
        .then((response) => response.data)
        .catch((err) => err.response);
